import { AutogenModelArCallRecord, AutogenRowArCallRecord } from "./autogen/AutogenModelArCallRecord";

export class ModelArCallRecord extends AutogenModelArCallRecord<RowArCallRecord> {
	constructor() {
		super(RowArCallRecord);
	}
}

export class RowArCallRecord extends AutogenRowArCallRecord {
}